import { InjectionToken } from "@angular/core";
import { ShoppingCartDto } from "projects/shared/lib/services/INTEGRA_Shop_Client";

export abstract class IProductAddToCartTemplateDialogService {

  abstract productAddToCartTemplateDialogShow(
    callbackCancel: () => void,
    callbackYes?: (cartTemplate: ShoppingCartDto) => void,
  ): unknown;

}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IProductAddToCartTemplateDialogServiceToken = new InjectionToken<IProductAddToCartTemplateDialogService>('IAuthServiceToken');
